<template>
  <div>
    <b-container fluid>
      <h3 class="mt-3 mb-3">Reverse Virtual Kit Master</h3>

      <div class="search_bar mb-3">
        <b-row>
          <b-col cols="4" class="pr-1">
            <b-form-file
              v-model="upload_file"
              placeholder="Choose a file..."
              size="sm"
            ></b-form-file>
          </b-col>

          <b-col class="text-left p-0">
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="onUploadFile"
              >Upload</b-button
            >
          </b-col>
        </b-row>
      </div>

      <div class="search_bar mb-3">
        <b-row>
          <b-col cols="2" class="pr-1">
            <b-form-select
              size="sm"
              v-model="search_criteria.channel_selected"
              :options="channel_options"
            />
          </b-col>
          <b-col cols="4" class="pr-1">
            <b-form-input
              id="input-small"
              size="sm"
              type="text"
              placeholder="Product SKU"
              v-model="search_criteria.keyword"
             @keyup.enter="onSearch"></b-form-input>
          </b-col>
          <b-col class="text-left p-0">
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="onSearch"
            >
              <font-awesome-icon class="mr-1" icon="search" />Search
            </b-button>
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="onExport"
            >
              Export
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <b-table
        responsive
        small
        outlined
        striped
        hover
        sticky-header="500px"
        :items="items"
        :fields="fields"
      >
        <template v-slot:head(chk_box)="data">
          <b-form-checkbox
            size="sm"
            plain
            id="chkbox_all"
            value="all"
            v-model="check_all_rows"
          ></b-form-checkbox>
        </template>
        <template v-slot:cell(chk_box)="data">
          <b-form-checkbox
            size="sm"
            class="chkbox_row"
            plain
            :id="'chkbox_row_' + data.index"
            v-model="data.item.is_checked"
          ></b-form-checkbox>
        </template>
        <template v-slot:cell(products)="data">
          <div
            :key="product_i"
            v-for="(product_v, product_i) in data.item.products"
          >
            {{ product_v.product_sku }} x {{ product_v.quantity }}
          </div>
        </template>

        <template v-slot:cell(action)="data">
          <b-button
            class="btn-action"
            size="sm"
            variant="danger"
            @click.stop="showModal_deleteVirtualKit(data.item)"
            v-if="
              checkPermission(
                $store.state.user_obj,
                'Controls',
                'Virtual Kit Master',
                'Delete',
                true
              )
            "
            >Delete</b-button
          >
        </template>
      </b-table>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <b-modal ref="modal_deleteVirtualKit" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>
              <strong>Are you sure to delete virtual kit?</strong>
            </b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_deleteVirtualKit"
            >Cancel</b-btn
          >
          <b-btn
            class="mt-3"
            variant="outline-success"
            @click="deleteVirtualKit()"
            >Confirm</b-btn
          >
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";
import global_function from "../mixins/global_function";
const fields = [
  {
    key: "channel",
    label: "Channel",
  },
  {
    key: "virtual_sku",
    label: "Virtual SKU",
  },
  {
    key: "channel_virtual_sku",
    label: "Channel Virtual SKU",
  },
  {
    key: "products",
    label: "Product SKU",
  },
  {
    key: "action",
    label: "Action",
  },
];

export default {
  name: "VirtualKitMaster",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    barcode: VueBarcode,
  },
  mixins: [apiService, global_function],
  data() {
    return {
      upload_file: [],
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      search_criteria: {
        keyword: "",
        channel_selected: null,
      },
      channel_options: [
        {
          text: "All Channel",
          value: null,
        },
      ],
      check_all_rows: false,
    };
  },
  async created() {
    await this.getVirtualKitMaster();
    let channels_response = await this.getChannels(this.$store.state.user_obj);
    for (let i in channels_response.channels) {
      this.channel_options.push({
        value: channels_response.channels[i].name,
        text: channels_response.channels[i].name,
      });
    }
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false,
    });
  },
  watch: {
    // whenever changes, this function will run
    check_all_rows: function (new_val, old_val) {
      if (new_val == "all") {
        // Check all
        for (let i in this.items) {
          this.items[i].is_checked = true;
        }
      } else {
        for (let i in this.items) {
          this.items[i].is_checked = false;
        }
      }
    },
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getVirtualKitMaster() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "virtual_kit_reverse_master_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
        },
      });
      this.items = response.data.virtual_kit_reverses;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    async onExport() {

      this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
      });

      this.$http({
      baseURL: `${this.API_HOST}`,
      url: "virtual_kit_reverse_master_get.php",
      method: "POST",
      data: {
        offset: 0,
        limit: 999999,
        mode: 'export',
        search_criteria: this.search_criteria,
        client_id: this.$store.state.user_obj.client_id,
        user_id: this.$store.state.user_obj.user_id,
      },
      responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "virtual_kit_reverse_master.xlsx");
        document.body.appendChild(link);
        link.click();
        this.loader.hide();
      });
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.getVirtualKitMaster();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getVirtualKitMaster();
    },

    async onUploadFile() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);
      formData.append("client_id", this.$store.state.user_obj.client_id);
      formData.append("user_id", this.$store.state.user_obj.user_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "virtual_kit_reverse_master_import.php",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      });

      if (response) {
        this.loader.hide();
        if (response.data.status == "success") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Upload Success",
          });
        } else {
          this.$eventHub.$emit("show_modal_message", {
            message_content: response.data.error_msg,
          });
        }
        this.getVirtualKitMaster();
      }
    },

    showModal_deleteVirtualKit(item) {
      this.updating_item = item;
      this.$refs.modal_deleteVirtualKit.show();
    },

    hideModal_deleteVirtualKit() {
      this.$refs.modal_deleteVirtualKit.hide();
    },

    async deleteVirtualKit() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "virtual_kit_reverse_master_delete.php",
        data: {
          virtual_kit_reverse_master_id: this.updating_item.id,
        },
      });

      if (response.data.status == "success") {
        this.alert_success_message = `Virtual Kit is deleted Successfully.`;
        this.showAlert_success = true;
        setTimeout(() => {
          this.showAlert_success = false;
          this.alert_success_message = "";
        }, 3000);
      }

      this.getVirtualKitMaster();
      this.hideModal_deleteVirtualKit();
    },
  },
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/VirtualKitReverseMaster.vue